export default __webpack_public_path__ + "static/media/6.118aa246.png";